import { useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../store';
import { refreshToken } from '../store/slices/authSlice';

const TOKEN_REFRESH_INTERVAL = 30 * 60 * 1000; // 30 minutes
const TOKEN_REFRESH_BEFORE_EXPIRY = 5 * 60 * 1000; // 5 minutes before expiry

export const useTokenRefresh = () => {
  const dispatch = useAppDispatch();
  const { isAuthenticated, token } = useAppSelector((state) => state.auth);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (isAuthenticated && token) {
      // Set up periodic token refresh
      intervalRef.current = setInterval(() => {
        dispatch(refreshToken());
      }, TOKEN_REFRESH_INTERVAL);

      // Check if token is close to expiry and refresh if needed
      try {
        const tokenPayload = JSON.parse(atob(token.split('.')[1]));
        const expiryTime = tokenPayload.exp * 1000; // Convert to milliseconds
        const currentTime = Date.now();
        const timeUntilExpiry = expiryTime - currentTime;

        if (timeUntilExpiry <= TOKEN_REFRESH_BEFORE_EXPIRY) {
          dispatch(refreshToken());
        }
      } catch (error) {
        console.warn('Failed to parse token for expiry check:', error);
      }
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [isAuthenticated, token, dispatch]);

  // Clean up on unmount
  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);
};
